import React from 'react';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ToggleSwitch } from '@/core/ToggleSwitch.atom';

export interface ToggleIF extends ValidatingFormComponent<any> {
  component: 'ToggleFormComponent';
  onChange: () => void;
  testId?: string;
  wrapperClasses?: string;
  label: string;
}

export const ToggleFormComponent: React.FunctionComponent<ToggleIF> = (props) => {
  const {
    name,
    validation,
    testId = 'toggleSwitch',
    wrapperClassNames,
    customErrorText,
    required = false,
    extendValidation,
    onChange,
    label,
    extraClassNames,
  } = props;

  const { t } = useTranslation();

  const formState = useForm().getState();
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    ((formState.modified && formState.modified[name]) || formState.submitFailed);

  const defaultValidation = (value: any) => required && !value;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <>
      <FormFieldWrapper
        wrapperClassNames={classNames('flexFill', wrapperClassNames)}
        testId={testId}
        showError={showError}
        errorClassNames="ml20"
        customErrorText={customErrorText}>
        <Field name={name} validate={appliedValidation}>
          {({ input, meta }) => {
            const { value } = getFormFieldProps(formState, input, meta, props);

            return (
              <ToggleSwitch
                testId={`${testId}-input`}
                isOn={value}
                onChange={() => onChange()}
                label={t(label)}
                extraClassNames={extraClassNames}
              />
            );
          }}
        </Field>
      </FormFieldWrapper>
    </>
  );
};
